export var PostActionType;
(function (PostActionType) {
    PostActionType["ADD_IMAGE_POST"] = "ADD_IMAGE_POST";
    PostActionType["HAS_MORE_DATA_STREAM"] = "HAS_MORE_DATA_STREAM";
    PostActionType["NOT_MORE_DATA_STREAM"] = "NOT_MORE_DATA_STREAM";
    PostActionType["REQUEST_PAGE_STREAM"] = "REQUEST_PAGE_STREAM";
    PostActionType["LAST_POST_STREAM"] = "LAST_POST_STREAM";
    PostActionType["HAS_MORE_DATA_PROFILE"] = "HAS_MORE_DATA_PROFILE";
    PostActionType["NOT_MORE_DATA_PROFILE"] = "NOT_MORE_DATA_PROFILE";
    PostActionType["REQUEST_PAGE_PROFILE"] = "REQUEST_PAGE_PROFILE";
    PostActionType["LAST_POST_PROFILE"] = "LAST_POST_PROFILE";
    PostActionType["ADD_VIDEO_POST"] = "ADD_VIDEO_POST";
    PostActionType["ADD_POST"] = "ADD_POST";
    PostActionType["UPDATE_POST"] = "UPDATE_POST";
    PostActionType["UPDATE_POST_COMMENTS"] = "UPDATE_POST_COMMENTS";
    PostActionType["UPDATE_POST_VOTES"] = "UPDATE_POST_VOTES";
    PostActionType["DELETE_POST"] = "DELETE_POST";
    PostActionType["ADD_LIST_POST"] = "ADD_LIST_POST";
    PostActionType["ADD_FILTERED_POST"] = "ADD_FILTERED_POST";
    PostActionType["CLEAR_ALL_DATA_POST"] = "CLEAR_ALL_DATA_POST";
    PostActionType["CLEAR_FILTERED_STATE"] = "CLEAR_FILTERED_STATE";
})(PostActionType || (PostActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/postActionType.ts
// module id = 218
// module chunks = 50